import { Navigate, useLocation } from 'react-router-dom'

import { useAppSelector } from '../../store'

const DefaultRoute: React.FC = () => {
  const { festivals } = useAppSelector((state) => state.app)
  const location = useLocation()
  const hash = window.location.hash.replace('#', '')
  const fallbackUrl = hash

  if (!festivals.length) {
    if (location?.state?.from === 'login') {
      return <Navigate to={'/'} state={{ from: 'login' }} />
    }
    return <Navigate to={'/'} />
  }

  const redirectToUrl = fallbackUrl || `/`
  return <Navigate to={redirectToUrl} />
}

export default DefaultRoute
